import { render, staticRenderFns } from "./FreestylerView.vue?vue&type=template&id=46c5e550&scoped=true"
import script from "./FreestylerView.vue?vue&type=script&lang=js"
export * from "./FreestylerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c5e550",
  null
  
)

export default component.exports